import PropTypes from 'prop-types';

const MyParishAppPropType = {
  submitting: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func,
  callbackAfterSubmit: PropTypes.func,
};

export default MyParishAppPropType;
